import React from 'react';
import cx from 'classnames';
import CountOfTotal from '../../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../../components/form/TextAreaForm';
import Panel from '../../../../../../components/outline/Panel';
import InputForm from '../../../../../../components/form/InputForm';
import { formRequiredRules } from '../../../../../../lib/formRules';
import {
  MAXIMUM_NUMBER_OF_SUB_PAGE_TITLE_TEXT,
  MAXIMUM_NUMBER_OF_SUB_PAGE_MEMO_TEXT,
} from '../../../../../../constants/service/app/widgetConstants';
import { REQUIRED_MSG } from '../../../../../../constants/service/common/formRulesConstants';
import './HomeSubSaveInfo.scss';

const HomeSubSaveInfo = (props) => {
  const { className, form, setData, pageInfo, isEditable = true, rightSide } = props;
  const { title, memo } = pageInfo;

  return (
    <Panel className={cx('home-sub-save-info', className)}>
      <div className="panel-header">
        <div className="title">서브 페이지 정보</div>
      </div>

      <div className="panel-body">
        <div className="page-info">
          {/*페이지 제목*/}
          <InputForm
            label={
              <span>
                페이지 제목
                <CountOfTotal content={title} maxCnt={MAXIMUM_NUMBER_OF_SUB_PAGE_TITLE_TEXT} />
              </span>
            }
            form={form}
            rules={[formRequiredRules(true, REQUIRED_MSG)]}
            initialValue={title}
            isEditable={isEditable}
            onChange={(value) =>
              setData({
                path: ['title'],
                value,
              })
            }
            maxLength={MAXIMUM_NUMBER_OF_SUB_PAGE_TITLE_TEXT}
            name="title"
          />

          {/* 메모 */}
          <TextAreaForm
            form={form}
            label={
              <span>
                메모
                <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_SUB_PAGE_MEMO_TEXT} />
              </span>
            }
            rules={[formRequiredRules(true, REQUIRED_MSG)]}
            initialValue={memo}
            isEditable={isEditable}
            maxLength={MAXIMUM_NUMBER_OF_SUB_PAGE_MEMO_TEXT}
            onChange={(value) =>
              setData({
                path: ['memo'],
                value,
              })
            }
            name="memo"
            autoSize={{ minRows: 4, maxRows: 8 }}
          />
        </div>

        {rightSide && <div className="right-side">{rightSide}</div>}
      </div>
    </Panel>
  );
};

export default HomeSubSaveInfo;
